import React from 'react';

import { Icon } from 'components/shared/Icon';
import { Link } from 'components/shared/Link';
import { Typography } from 'components/shared/Typography';

import styles from './Breadcrumbs.module.scss';

const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: any }) => (
  <div className={styles.breadcrumbs}>
    <div className={styles.items}>
      {breadcrumbs.map(
        (
          { match, breadcrumb }: { match: any; breadcrumb: any },
          breadcrumbIndex: any,
        ) => (
          <div className={styles.item} key={breadcrumbIndex}>
            {breadcrumbIndex === breadcrumbs.length - 1 ? (
              <Typography
                className={styles.text}
                variant="body3"
                weight="medium"
                mode="compact"
              >
                {breadcrumb}
              </Typography>
            ) : (
              <Link className={styles.link} to={match.pathname}>
                {breadcrumb}
              </Link>
            )}
            {breadcrumbIndex !== breadcrumbs.length - 1 && (
              <Icon className={styles.icon} name="chevronRight" />
            )}
          </div>
        ),
      )}
    </div>
  </div>
);

export default React.memo(Breadcrumbs) as any;
